// MODULES
import React from "react";
import PropTypes from "prop-types";

// COMPONENTS
import Checkbox from "@components/Checkbox/Checkbox";

// HELPERS
import {createClassName} from "@helpers/utils";


export default class OptionsList extends React.PureComponent {
	static propTypes = {
		type: PropTypes.string.isRequired,
		name: PropTypes.string,
		description: PropTypes.string,
		options: PropTypes.array.isRequired,
		orientation: PropTypes.string.isRequired
	};

	static defaultProps = {
		type: "checkbox",
		orientation: "vertical"
	};

	render() {
		const {props} = this;
		const {type, name, description, options, orientation, onChange} = props;
		const classes = createClassName("Cob-OptionsList", {
			"horizontal": orientation === "horizontal",
			"vertical": orientation === "vertical",
			"custom-description": !!description && typeof description !== "string"
		});

		return (
			<div className={classes} style={props.style}>
				<div className="Cob-OptionsList-description">{description}</div>
				<div className="Cob-OptionsList-options">
					{options.map((option, index) => (
						<OptionsListOption
							key={option.key || index}
							type={option.type || type}
							name={option.name || name}
							option={option}
                            disabled={option.disabled}
							index={index}
							onChange={onChange ? this._onChange : undefined}
						/>
					))}
				</div>
			</div>
		);
	}

	// Internal methods
	_onChange = (option, index) => {
		const {onChange} = this.props;
		onChange(this.props, option, index);
	};
}


// PRIVATE COMPONENTS
class OptionsListOption extends React.PureComponent {
	static propTypes = {
		type: PropTypes.string.isRequired,
		name: PropTypes.string,
		onChange: PropTypes.func
	};

	render() {
		const {props} = this;
		const {type, name, option, onChange, disabled} = props;

		return (
			<Checkbox
				className="Cob-OptionsList-Option"
				type={type}
				name={name}
				label={option.label}
				value={option.value}
				checked={option.checked || false}
				onChange={onChange ? this._onChange : undefined}
                disabled={disabled}
			/>
		);
	}

	// Internal methods
	_onChange = (checked) => {
		const {props} = this;
		const {index, onChange} = props;
		const option = {...props.option, checked};

		onChange(option, index);
	};
}


// WEBPACK FOOTER //
// ./src/routes/Cob/components/OptionsList/OptionsList.js